import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
import MUILink from "@mui/material/Link";
import MUITypography from "@mui/material/Typography";
export var ELSLink = function ELSLink(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MUITypography, {
    component: "span"
  }, /*#__PURE__*/React.createElement(MUILink, _extends({
    className: "es-link ".concat(className ? "".concat(className, " ") : "")
  }, props), props.children));
};